import AdminLayout from "../layout/AdminLayout";
import DocumentsList from "./DocumentsView"

export default function AdminSidebarPage() {
  return (
    <AdminLayout>
      <DocumentsList />
    </AdminLayout>
  );
}